import React from 'react'

const intro = () => {
  return (
    <div className="intro">
      <p>This programme takes the image dropped into the box, analyses the image, and describes what the 
          image portrays back to the user. 
      </p>
    </div>
  )
}


export default intro;